import { Pipe, PipeTransform } from '@angular/core';
import { SeraButton } from '../ui/sera-table/models/SeraCustomActions';
import { ButtonDisplayMode } from '../ui/sera-table/models/ButtonDisplayMode';
@Pipe({
    name: 'filterButtonBasedOnDisplayMode',
    standalone: false
})
export class FilterButtonBasedOnDisplayModePipe implements PipeTransform {
    transform(buttons: SeraButton[], isEditMode: boolean, rowData?: any): SeraButton[] {
        if (rowData) {
            if (isEditMode) {
                // CASE OF LINKED ANALYSIS
                if (rowData.parent?.analysisKey) {
                    return buttons?.filter(button => button.displayMode === ButtonDisplayMode.View);
                } else {
                    return this.getButtonsForMultipleDisplayMode(buttons, ButtonDisplayMode.Edit);
                }
            }
            return this.getButtonsForMultipleDisplayMode(buttons, ButtonDisplayMode.View);
        } else {
            return isEditMode
                ? this.getButtonsForMultipleDisplayMode(buttons, ButtonDisplayMode.Edit)
                : this.getButtonsForMultipleDisplayMode(buttons, ButtonDisplayMode.View);
        }
    }

    private getButtonsForMultipleDisplayMode(buttons: SeraButton[], secondaryDisplayMode: ButtonDisplayMode) {
        const buttonsList = [];
        if (buttons) {
            for (const button of buttons) {
                if (button.displayMode == null || button.displayMode === secondaryDisplayMode || button.displayMode === ButtonDisplayMode.View_Edit) {
                    buttonsList.push(button);
                }
            }
        }
        return buttonsList;
    }
}
